module.exports = __webpack_public_path__ + "img/motivauswahl_3.72a415fd.jpg";